export enum FeatureFlag {
  BILLING_USAGE_REVAMP = 'billing-usage-revamp',
  UI_POLISH_NEW_DESIGN = 'ui-polish-new-design',
  CLOUD_COMPASS_RENEWAL = 'cloud-compass-renewal'
}

export const localFeatureFlagValues = {
  [FeatureFlag.BILLING_USAGE_REVAMP]: false,
  [FeatureFlag.UI_POLISH_NEW_DESIGN]: false,
  [FeatureFlag.CLOUD_COMPASS_RENEWAL]: false
};

export type FeatureFlags = typeof localFeatureFlagValues;

export const FEATURE_FLAG_OVERRIDES_STORAGE_KEY = 'ENV0_FEATURE_FLAG_OVERRIDES';

export const readFeatureFlagOverrides = (): Partial<FeatureFlags> => {
  try {
    const stored = localStorage.getItem(FEATURE_FLAG_OVERRIDES_STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
};
